







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class StatusBadge extends Vue {
  @Prop({ default: '' }) readonly status?: string;

  get tPrefix() {
    return 'common.components.statusBadge';
  }

  get active() {
    return this.status === 'active';
  }
}
